import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

export type PaneType = 'left' | 'right';

@Component({
  selector: 'craft-slide-panel',
  templateUrl: './craft-slide-panel.component.html',
  styleUrls: ['./craft-slide-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slide', [
      state('left', style({ transform: 'translateX(0)' })),
      state('right', style({ transform: 'translateX(-50%)' })),
      transition('* => *', animate(300)),
    ]),
  ],
  standalone: false,
})
export class CraftSlidePanelComponent implements OnInit {
  @Input() public activePane: PaneType = 'left';

  constructor() {}

  public ngOnInit() {}
}
